<template>
<div :class="bem()" :style="`padding:0px ${vm.width < 400? 40: 80}px`">
    <div :class="bem('title')">更改密码</div>
    <div :class="bem('item')">
        <PhoneNumber v-model="vm.form.phone" :countries="vm.countries" />
    </div>
    <div :class="bem('item')">
        <Input v-model="vm.form.verifyCode" maxlength="4" autocomplete="off" placeholder="输入短信中的验证码"/>
        <verifyCode
            :sendVerifyCode="sendVerifyCode"
            type="find_password"/>
    </div>
    <div :class="bem('item')">
        <Input
            label="新密码"
            type="password"
            v-model="vm.form.password"
            @enter="resetPassword"
            name="new-password"
            autocomplete="new-password"
            placeholder="输入6-30位新密码"
            maxlength="30"/>
    </div>

    <Button
        :class="bem('submit')"
        type="primary"
        size="large"
        @click="resetPassword"
        nativeType="submit"
        :disabled="loading">更改密码</Button>
    <GoToLogin tips="想起密码？"/>
</div>

</template>
<script>
import _get from "lodash/get";
import _Input from "@gaoding/gdui/lib/input";
import _Button from "@gaoding/gdui/lib/button";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PhoneNumber from './phone-number/index.vue';
import GoToLogin from './components/GoToLogin.vue';
import verifyCode from './verify-code.vue';
import bemMixin from './bem';
export default {
  name: 'g-auth-resetpwd',
  components: {
    Button: _Button,
    PhoneNumber: PhoneNumber,
    Input: _Input,
    verifyCode: verifyCode,
    GoToLogin: GoToLogin
  },
  mixins: [bemMixin],
  inject: ['vm'],
  data: function data() {
    return {
      loading: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.codePendingTimer);
  },
  methods: {
    sendVerifyCode: function sendVerifyCode() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.vm.requestUms('sendVerifyCode', _objectSpread(_objectSpread({}, _this.vm.form), {}, {
                  type: 'find_password'
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetPassword: function resetPassword() {
      var _this2 = this;

      var password = _get(this.vm, 'form.password');

      var phoneNumber = _get(this.vm, 'form.phone.number');

      var verifyCode = _get(this.vm, 'form.verifyCode');

      if (!phoneNumber) {
        var verifyError = new Error('请输入正确的手机号');
        this.vm.$emit('error', {
          error: verifyError,
          action: 'resetpwd',
          type: 'password'
        });
        return;
      }

      ;

      if (!password) {
        var _verifyError = new Error('请输入密码');

        this.vm.$emit('error', {
          error: _verifyError,
          action: 'resetpwd',
          type: 'password'
        });
        return;
      }

      ;

      if (!verifyCode) {
        var _verifyError2 = new Error('请输入验证码');

        this.vm.$emit('error', {
          error: _verifyError2,
          action: 'resetpwd',
          type: 'password'
        });
        return;
      }

      ;
      if (this.loading) return;
      this.loading = true;
      this.vm.requestUms('resetPassword', this.vm.form).then(function () {
        _this2.vm.switchType('phone');

        _this2.vm.$emit('success', {
          action: 'resetpwd',
          type: 'password'
        });

        _this2.loading = false;
      }).catch(function (error) {
        _this2.loading = false;

        _this2.vm.$emit('error', {
          error: error,
          action: 'resetpwd',
          type: 'password'
        });
      });
    }
  }
};
</script>
<style>
/*
 * @Author: 天吾
 * @Date: 2019-01-23 16:29:55
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-11-22 11:24:33
 */
/*
    size 统一用  sm base lg  表示,  对于不能满足的情况, 仿照衣服尺寸加上 x(EXTRA) 比如  font-size-xlg 表示特大
*/
.g-auth-resetpwd input::placeholder {
  font-size: 12px;
}
.g-auth-resetpwd .g-auth-resetpwd__title {
  height: 20px;
  font-size: 20px;
  font-weight: 600;
  color: #000;
  text-align: center;
  line-height: 20px;
  margin-bottom: 32px;
}
.g-auth-resetpwd .g-auth-resetpwd__item {
  display: flex;
}
.g-auth-resetpwd .g-auth-resetpwd__item + .g-auth-resetpwd__item {
  margin-top: 16px;
}
.g-auth-resetpwd .g-auth-resetpwd__submit {
  width: 100%;
  height: 45px;
  line-height: 45px;
  margin-top: 24px;
  font-weight: 600;
}

</style>
